import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Card, Tag, Spin } from "antd";
import { isTablet } from "react-device-detect";
import PropertyResults from "../Toolbar/PropertyResults";
import "./WelcomeCard.css";
import { useAvvs } from "../../Widgets/avv/useAvv";
import houseImage from "../../assets/images/house.png";
import LoupeInmanBlue from "../../assets/images/LoupeInmanBlue.svg";
import { useQueryClient } from "react-query";
import {
  prefetchReportQueries,
  prefetchPropertyData,
} from "../../Widgets/queries/prefetchPropertyData";
import {
  getWelcomeCardBackgroundColor,
  toTitleCase,
} from "../../helpers/formatters";
import { processAvvData } from "../../helpers/processors";

const imageStyle = {
  display: "block",
  marginLeft: "auto",
  marginRight: "auto",
  width: "100%",
};

const WelcomeCard = () => {
  const { data: avvs, isLoading: avvLoading, isError: avvError } = useAvvs();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [fetching, setFetching] = useState(false);

  const handleAvvClick = async (process) => {
    setFetching(true);
    const filters = {
      code: process?.search_string.slice(-5),
      reportName: process?.search_string,
      propType: "address",
      zipcode: process?.search_string.slice(-5),
    };

    try {
      await prefetchReportQueries(queryClient, filters);
      await prefetchPropertyData(queryClient, filters);
      navigate(
        `/report/${encodeURIComponent(
          process?.search_string
        )}/address/${encodeURIComponent(process?.search_string.slice(-5))}`
      );
    } catch (error) {
      console.error("Error prefetching queries:", error);
    } finally {
      setFetching(false);
    }
  };
  const processedData = useMemo(() => processAvvData(avvs), [avvs]);
  if (avvLoading || fetching) {
    return (
      <div className="search-loading">
        <Spin />
      </div>
    );
  }

  if (avvError) {
    return <div>Error...</div>;
  }

  return (
    <div className="welcome-card-container">
      <Row
        type="flex"
        align="middle"
        justify="center"
        style={{
          minHeight: isTablet ? "60vh" : "80vh",
          paddingBottom: isTablet ? "0" : "30px",
        }}
      >
        <Col
          xl={{ span: 14 }}
          lg={{ span: 16 }}
          md={{ span: 18 }}
          sm={{ span: 18 }}
          xs={{ span: 22 }}
          style={{ textAlign: "center" }}
        >
          <img alt="houses" style={imageStyle} src={houseImage} />
          <div style={{ marginTop: "20px" }}>
            <h1 className="text-blue">
              <img
                alt="loupe"
                src={LoupeInmanBlue}
                style={{ height: "30px" }}
              />
              <span style={{ marginLeft: "20px" }}>
                Enter <span className="text-bold-extra">Metro,</span>
              </span>
              <span className="text-bold-extra"> Zip</span>
              <span style={{ padding: 5 }}>or</span>
              <span className="text-bold-extra">Address</span>
              <PropertyResults isReportSearch={true} />
            </h1>
          </div>

          <div style={{ marginTop: "20px" }}>
            <Row gutter={[16, 16]}>
              {processedData?.map((process, index) => (
                <Col key={index} xl={6} lg={8} md={8} sm={12} xs={24}>
                  <Card
                    hoverable
                    style={{
                      height: "150px",
                      borderRadius: "10px",
                      boxShadow: "0 0 10px rgba(0,0,0,0.2)",
                      backgroundColor: getWelcomeCardBackgroundColor(process),
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                    }}
                    onClick={() => handleAvvClick(process)}
                  >
                    <div
                      style={{
                        textTransform: "uppercase",
                        fontWeight: "bold",
                        wordBreak: "break-word",
                        overflowWrap: "break-word",
                        hyphens: "auto",
                        maxHeight: "120px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        display: "-webkit-box",
                        WebkitLineClamp: 4,
                        WebkitBoxOrient: "vertical",
                      }}
                    >
                      {process?.search_string}{" "}
                    </div>
                    <Tag
                      color={getWelcomeCardBackgroundColor(process)}
                      style={{ alignSelf: "flex-start", marginTop: "16px" }}
                    >
                      <span
                        style={{ color: "black", textTransform: "uppercase" }}
                      >
                        {process?.report_type === "avv" ? "AVV" : "AVM"} REPORT:{" "}
                        {toTitleCase(process?.status).toUpperCase()}
                      </span>
                    </Tag>
                  </Card>
                </Col>
              ))}
            </Row>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default WelcomeCard;
